import GoogleAnalyticsEvent from "dataTransferObjects/googleAnalyticsEvent";
import GoogleAnalyticsEventAction from "enums/googleAnalyticsEventAction";
import GoogleAnalyticsEventCategory from "enums/googleAnalyticsEventCategory";

/* Creates a new instance of a Google Analytics Tdv Event Mixin to track users events when the user subimits a lead. */
export default class EventTrackingTdvEventsMixin {
    constructor(model) {
      Object.assign(this, model);
    }
  
    getGoogleAnalyticsData() {
      return new GoogleAnalyticsEvent(
        GoogleAnalyticsEventCategory.TdvEvents.toString(), 
        GoogleAnalyticsEventAction.DirectLeads.toString(), 
        this.eventLabel);
    }
  }